export const getColor = (color, weight = '500') => {
    return ({theme}) => theme.vars.colors[color][weight]
}

export const getPaddings = (from, padding) => {
    return ({theme}) => theme.vars.sizes[from].paddings[padding].join(' ')
}

export const getPaddingsInline = (from, padding) => {
    return ({theme}) => theme.vars.sizes[from].paddings[padding].at(-1)
}

export const getPaddingsBlock = (from, padding) => {
    return ({theme}) => theme.vars.sizes[from].paddings[padding].at(0)
}

export const getFontSize = (type, size) => {
    return ({theme}) => theme.vars.fontSizes[type][size]
}

export const getLetterSpacing = (size) => {
    return ({theme}) => theme.vars.letterSpacings[size]
}

export const getFontWeight = (weight) => {
    return ({theme}) => theme.vars.fontWeights[weight]
}

export const getLineHeight = (from, lineHeight) => {
    return ({theme}) => theme.vars.lineHeights[from][lineHeight]
}

export const getMedias = (device) => {
    return ({theme}) => theme.medias[device]
}

export const getFontFamilyVariable = (name) => {
    return ({theme}) => `var(${theme.vars.fontFamilies[name]})`
}
